import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const site24x7 = defineConnector({
  identifier: "site24x7",
  name: "Site24x7",
  tagLine: "Infrastructure and website monitoring",
  logo,
  protocol: "http",
  tags: ["observability", "it"],
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.accessToken,
        scheme: "Zoho-oauthtoken",
      },
    ]),
  steps: [
    {
      title: "Get your Site24x7 access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Site24x7, generate an OAuth access token for the APIs. Site24x7 sends it in the `Authorization` header using the `Zoho-oauthtoken` scheme.",
        },
      ],
    },
    {
      title: "Enter your Site24x7 details",
      items: [
        {
          kind: "url",
          label: "API base URL",
          required: true,
          placeholder: "https://www.site24x7.com/api",
          target: { kind: "configuration", field: "apiBaseUrl" },
          helperText:
            "Use the data center base URL that matches your Site24x7 account.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiBaseUrl }) =>
      `${apiBaseUrl || "https://www.site24x7.com/api"}/current_status`,
  },
  defaultUrlPattern: ({ apiBaseUrl }) =>
    urlToPattern(apiBaseUrl, "https://.*site24x7\\.com/api/.*"),
});
